import React from "react";
import { useTranslation } from "react-i18next";
import { Text, View } from "react-native";
import BackNavigationButton from "@/src/components/ui-kit/back-navigation";
import ScSearchInput from "./search-bar";

type HeaderBarProps =
  | { variant: "search"; placeholder: string }
  | { variant: "topic"; title: string };

const HeaderBar: React.FC<HeaderBarProps> = (props) => {
  const { t } = useTranslation();

  if (props.variant === "search") {
    return (
      <View className="md:bg-chalk md:px-6 md:py-4 md:rounded-[16px] md:border md:border-ash-3">
        <View className="flex-row items-center gap-4">
          <BackNavigationButton
            iconSize={18}
            iconClassName="text-ash-2"
            labelClassName="font-medium text-onyx"
            containerStyle={{ marginBottom: 0 }}
          />

          <View className="flex-1">
            <ScSearchInput
              placeholderKey={props.placeholder}
              containerClassName="rounded-full"
            />
          </View>
        </View>
      </View>
    );
  }

  return (
    <View className="flex-row items-center justify-between px-1 md:border md:border-ash-3 md:px-6 md:py-4 md:rounded-[16px] md:bg-chalk">
      <BackNavigationButton
        iconSize={18}
        iconClassName="text-ash-2"
        labelClassName="font-medium text-onyx"
        containerStyle={{ marginBottom: 0 }}
      />

      <Text className="font-medium text-onyx">{t(props.title)}</Text>

      {/* Spacer for alignment */}
      <View className="w-6" />
    </View>
  );
};

export default HeaderBar;
